import { render, staticRenderFns } from "./JcdcBadge.vue?vue&type=template&id=6b175dfa"
import script from "./JcdcBadge.vue?vue&type=script&lang=ts"
export * from "./JcdcBadge.vue?vue&type=script&lang=ts"
import style0 from "./JcdcBadge.vue?vue&type=style&index=0&id=6b175dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports